import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=e3ca9b30&scoped=true"
import script from "./SimplePagination.vue?vue&type=script&lang=ts"
export * from "./SimplePagination.vue?vue&type=script&lang=ts"
import style0 from "./SimplePagination.vue?vue&type=style&index=0&id=e3ca9b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ca9b30",
  null
  
)

export default component.exports